import { render, staticRenderFns } from "./StepsSecond.vue?vue&type=template&id=938f0a52&scoped=true"
import script from "./StepsSecond.vue?vue&type=script&lang=js"
export * from "./StepsSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938f0a52",
  null
  
)

export default component.exports